export default import.meta.ROLLUP_FILE_URL_x0Xf35NS$rw1gNjZwz1HMw